import { render, staticRenderFns } from "./NewHowItWorks.vue?vue&type=template&id=40e2962a&scoped=true&"
import script from "./NewHowItWorks.vue?vue&type=script&lang=js&"
export * from "./NewHowItWorks.vue?vue&type=script&lang=js&"
import style0 from "./NewHowItWorks.vue?vue&type=style&index=0&id=40e2962a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2962a",
  null
  
)

export default component.exports